import React from 'react';
import { DataLayerGraphView } from '@/modules/shared/DataLayers';
import { fleetAbuseChartConfig } from '../dataLayerAdapters/FleetAbuseChartDataLayer';
import { useOperatorProficiency } from '@/contexts/OperatorProficiencyContext';

interface FleetAbuseChartProps {
  className?: string;
}

export const FleetAbuseChart: React.FC<FleetAbuseChartProps> = ({ className = '' }) => {
  const { chartData, loading } = useOperatorProficiency();

  // Let the DataLayer handle empty state with proper card wrapper
  return (
    <DataLayerGraphView
      graph={fleetAbuseChartConfig}
      data={chartData}
      legendItems={[]}
      onLegendToggle={() => {}}
      loading={loading}
      className={className}
    />
  );
};
